module.exports = __webpack_public_path__ + "img/bugis-cover.3912049a.jpg";